module.exports = __webpack_public_path__ + "static/media/Ds3v6.5c779d9a.mp3";